import React from "react";
import { SecurityFeatures } from "components/content";
import { type Theme, type ThemeBgColor } from "contexts/color-theme";
import { useWarehouseCdp } from "contexts/warehouse-cdp-context";

type WarehouseSecurityFeaturesProps = {
  theme?: Theme;
  bgColor?: ThemeBgColor;
};

export function WarehouseSecurityFeatures({ bgColor, theme = "light" }: WarehouseSecurityFeaturesProps) {
  const { warehouse } = useWarehouseCdp();

  return (
    <SecurityFeatures
      noContainerPx
      as="div"
      my={0}
      pb="small"
      theme={theme}
      themeBgColor={bgColor}
      title="Composable CDPs are more secure"
      description={`Hightouch doesn’t store your data. Instead, we simply read from ${warehouse.name}, where it stays safe and sound.`}
      textMaxW="580px"
    />
  );
}
